import React from "react";
import { NavLink, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Logo from "@/components/Logo";

export default function Footer() {
  const { t } = useTranslation();
  const { lang } = useParams();
  const base = `/${lang || "ar"}`;

  const openCookiePrefs = () => {
    window.dispatchEvent(new CustomEvent("fp:open-cookie-prefs"));
  };

  return (
    <footer className="fp-footer">
      <div className="fp-footer__grid">
        <div className="fp-footer__col fp-footer__brand-col">
          <Logo variant="light" />
          <p className="fp-footer__about">{t("footer.about_body")}</p>
        </div>

        <div className="fp-footer__col">
          <h4 className="fp-footer__title">{t("footer.nav_title")}</h4>
          <ul className="fp-footer__list">
            <li><NavLink to={base}>{t("header.nav.home")}</NavLink></li>
            <li><a href={base + "#about"}>{t("header.nav.about")}</a></li>
            <li><a href={base + "#how"}>{t("header.nav.how")}</a></li>
            <li><a href={base + "#benefits"}>{t("header.nav.benefits")}</a></li>
            <li><a href={base + "#faq"}>{t("header.nav.faq")}</a></li>
            <li><a href={base + "#contact"}>{t("header.nav.contact")}</a></li>
          </ul>
        </div>

        <div className="fp-footer__col">
          <h4 className="fp-footer__title">{t("footer.legal_title")}</h4>
          <ul className="fp-footer__list">
            <li><NavLink to={base + "/privacy"}>{t("policies_teaser.privacy")}</NavLink></li>
            <li><NavLink to={base + "/cookies"}>{t("policies_teaser.cookies")}</NavLink></li>
            <li><NavLink to={base + "/terms"}>{t("policies_teaser.terms")}</NavLink></li>
            <li>
              <button type="button" className="fp-footer__linkbtn" onClick={openCookiePrefs}>
                {t("cookie_banner.manage")}
              </button>
            </li>
          </ul>
        </div>

        <div className="fp-footer__col">
          <h4 className="fp-footer__title">{t("footer.contact_title")}</h4>
          <ul className="fp-footer__list fp-footer__list--contact">
            <li><a href={`mailto:${t("footer.email")}`}>{t("footer.email")}</a></li>
            <li><a href={`tel:${t("footer.phone").replace(/[^+0-9]/g, "")}`}>{t("footer.phone")}</a></li>
            <li className="fp-footer__addr">{t("footer.address")}</li>
          </ul>
        </div>
      </div>

      <div className="fp-footer__legal">
        <p>{t("footer.company_name")} · {t("footer.cuit")}</p>
        <p>{t("footer.registration")}</p>
        <p>{t("footer.license")} · {t("footer.jurisdiction")}</p>
        <p>{t("footer.founded")}</p>
      </div>

      <div className="fp-footer__bottom">
        <span>{t("footer.copyright")}</span>
        <button
          type="button"
          className="fp-footer__toptop"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
        >
          {t("footer.scroll_top")} ↑
        </button>
      </div>
    </footer>
  );
}
